import React, { useEffect, useState } from 'react';
import Checkbox from '../../commonComponents/atoms/checkbox';
import formsHOC from '../../formComponents/formikHOC';
import Label from '../../commonComponents/atoms/label';

const UKExchangeReasonOptions = [
  { value: 'TOO_LONG', label: 'Too long' },
  { value: 'TOO_SHORT', label: 'Too short' },
  { value: 'TOO_LOOSE', label: 'Too loose' },
  { value: 'TOO_TIGHT', label: 'Too tight' },
  { value: 'WRONG_STYLE_SENT', label: 'Wrong style sent' },
  { value: 'ARRIVED_TOO_LATE', label: 'Arrived too late' },
  { value: 'NOT_AS_EXPECTED', label: 'Not as expected' },
  { value: 'FAULTY', label: 'Faulty' },
  { value: 'ORDERED_MULTIPLE_PAIRS', label: 'Ordered multiple pairs' },
  { value: 'OTHER', label: 'Other' },
];

const USExchangeReasonOptions = UKExchangeReasonOptions.slice(0, 4);

const {
  locale: { country },
} = window.inlineGlobalConfig;

const exchangeReasonOptions = country === 'uk' ? UKExchangeReasonOptions : USExchangeReasonOptions;

const ExchangeReasonForm = ({
  errors,
  touched,
  handleChange,
  entryNumber,
  setFormValues,
  availableAmount,
  selected,
  exchangeReason,
}) => {
  const [checkedItems, setCheckedItems] = useState([]);
  const [reasons, setReasons] = useState({});

  useEffect(() => {
    if (selected) {
      setCheckedItems([entryNumber]);
      setReasons({ [entryNumber]: exchangeReason });
    }
  }, [selected, exchangeReason, entryNumber]);

  const renderExchangeReasonOptions = exchangeReasonOptions.map(option => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  ));

  const handleCheckboxChange = event => {
    const { checked } = event.target;
    setCheckedItems(prevState => {
      if (checked) {
        return [...prevState, entryNumber];
      }
      return prevState.filter(item => item !== entryNumber);
    });

    if (checked) {
      setFormValues(prevState => {
        if (prevState.entries.some(entry => entry.lineNumber === entryNumber)) {
          return prevState;
        }
        return {
          ...prevState,
          entries: [...prevState.entries, { lineNumber: entryNumber, reason: '' }],
        };
      });
    } else {
      setFormValues(prevState => ({
        ...prevState,
        entries: prevState.entries.filter(entry => entry.lineNumber !== entryNumber),
      }));
      setReasons(prevState => ({
        ...prevState,
        [entryNumber]: '',
      }));
    }
  };

  const handleSelectChange = event => {
    const { value } = event.target;
    handleChange(event);
    setFormValues(prevState => {
      const updatedEntries = prevState.entries.map(entry =>
        entry.lineNumber === entryNumber ? { ...entry, reason: value } : entry
      );
      return { ...prevState, entries: updatedEntries };
    });
    setReasons(prevState => ({
      ...prevState,
      [entryNumber]: value,
    }));
  };

  const isChecked = checkedItems.includes(entryNumber);
  const selectedReason = reasons[entryNumber] || '';

  return (
    <div className="exchange-section">
      {availableAmount[1] === '0' ? (
        <p className="exchange-section__message">Item not eligible for exchange</p>
      ) : (
        <>
          <Checkbox
            checkboxName={`exchangeItem_${entryNumber}`}
            checkboxLabel="Exchange this item"
            checkboxClass="exchange-checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          {isChecked && (
            <>
              <Label className="exchange-section__reason" htmlFor={`reason_${entryNumber}`}>
                Reason for exchange (required)
              </Label>
              <select
                id={`reason_${entryNumber}`}
                name={`reason_${entryNumber}`}
                value={selectedReason}
                onChange={handleSelectChange}
                className={errors.reason && touched.reason ? '_is-error' : ''}
              >
                <option value="">Select a reason</option>
                {renderExchangeReasonOptions}
              </select>
            </>
          )}
          {errors.reason && touched.reason && <div className="error">{errors.reason}</div>}
        </>
      )}
    </div>
  );
};

const EnhancedExchangeReason = formsHOC({
  mapPropsToValues: () => ({ entries: [] }),
  validate: values => {
    const errors = {};
    values.entries.forEach((entry, index) => {
      if (!entry.reason) {
        errors[`entries[${index}].reason`] = 'Reason for exchange is required.';
      }
    });
    return errors;
  },
  formName: 'ExchangeReasonForm',
})(ExchangeReasonForm);

export default EnhancedExchangeReason;
